<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/doggyhub/tabs/articles"></ion-back-button>
    </ion-buttons>
    <ion-title>Article</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <ion-grid *ngIf="!isLoading">
    <ion-row>
      <ion-col
        class="ion-text-center title"
        sizeMd="10"
        offsetMd="1"
        sizeXl="8"
        offsetXl="2"
      >
        {{article.title}}
      </ion-col>
    </ion-row>
    <ion-row
      ><ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <div class="metadata">
          By: {{article.addedBy + " on " + articleDate}}
        </div>
        <div>
          <ion-img class="header-image" [src]="article.image"></ion-img>
        </div>

        <div class="icons">
          <a
            style="color: #128c7e"
            [href]="'whatsapp://send?text=Check out this article!! ' + url"
            data-action="share/whatsapp/share"
            ><ion-icon name="logo-whatsapp"></ion-icon
          ></a>
          <ion-icon
            class="icon"
            name="copy-outline"
            (click)="copyLink()"
          ></ion-icon>

          <ion-icon
            name="share-social-outline"
            (click)="shareArticle()"
            class="pointer"
          ></ion-icon>
        </div> </ion-col
    ></ion-row>
    <ion-row>
      <ion-col class="prewrap" sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <div [innerHTML]="article.content"></div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
